module.exports = __webpack_public_path__ + "static/abc-rally-photo-e567bff86ab3da4fe10a0ae9ffdef36e.jpg";